<mat-accordion class="clean" *ngIf="showAccordion">
  <mat-expansion-panel [expanded]="true" [hideToggle]="true">
    <mat-expansion-panel-header>
      <mat-panel-title class="{{displayBtn}}">
        <button class="btn btn-icon-left btn-filter">
          <mat-icon class="inline">filter_list</mat-icon>
          <span>{{'shared.filters.chain.select' | translate }}</span>
          <mat-icon class="inline arrow-up">arrow_drop_up</mat-icon>
          <mat-icon class="inline arrow-down">arrow_drop_down</mat-icon>
        </button>
      </mat-panel-title>
    </mat-expansion-panel-header>


    <div class="filters">
      <label class="inline">{{'shared.filters.chain.select_one_or_more' | translate }}</label>
      <button class="btn btn-link" (click)="selectedAll(true)">{{'commons.select_all' | translate }}</button>
      <button class="btn btn-link" (click)="selectedAll(false)">{{'commons.unselect_all' | translate }}</button>
    </div>


    <div class="row list-legends align-items-center" >
      <div class="col-3 legend-col" *ngFor="let data of lineChartData; let i=index">
        <div class="legend" (click)="toggleLegend(data)" [class.unselected]="data.hidden">
          <i class="fas fa-circle point-customer" [ngStyle]="{'color': lineChartColors[i]?.backgroundColor || ''}"></i>
          <div class="ellipsis">
            {{data.label}}
          </div>
        </div>
      </div>
    </div>

  </mat-expansion-panel>

</mat-accordion>

<ng-container *ngIf="hideContent">
  <button
    class="tw-bg-transparent tw-shadow-none tw-text-gray-400 hover:tw-underline tw-p-0 tw-text-sm tw-font-normal"
    (click)="hideContent = !hideContent"
  >
    {{'commons.show_legend' | translate }}
  </button>
</ng-container>

<ng-container *ngIf="!hideContent">
  <div class="tw-flex tw-items-start">
    <div>
      <button
        class="tw-bg-transparent tw-shadow-none tw-text-gray-400 hover:tw-underline tw-p-0 tw-text-sm tw-font-normal"
        (click)="hideContent = !hideContent"
      >
        {{'commons.hide_legend' | translate }}
      </button>
      <div class="tw-flex tw-flex-col tw-mr-6 tw-min-w-[140px]">
        <!-- Filtros -->
        <div class="tw-mb-3">
          <div class="tw-text-gray-400 tw-text-sm tw-mb-0.5">
            {{'shared.filters.chain.select_one_or_more' | translate }}
          </div>
          <div class="tw-flex tw-items-center tw-space-x-1">
            <button
              class="tw-bg-transparent tw-shadow-none tw-text-gray-400 hover:tw-underline tw-p-0 tw-text-sm tw-font-normal"
              (click)="selectedAll(true)"
            >
              {{'user_management.all' | translate }}
            </button>
            <span class="tw-text-gray-300 tw-px-0.5">|</span>
            <button
              class="tw-bg-transparent tw-shadow-none tw-text-gray-400 hover:tw-underline tw-p-0 tw-text-sm tw-font-normal"
              (click)="selectedAll(false)"
            >
              {{'filters.actions.options.delete' | translate }}
            </button>
          </div>
        </div>
      
        <!-- Buscador -->
        <div class="tw-w-full">
          <div class="tw-relative">
            <div class="tw-absolute tw-inset-y-0 tw-left-0 tw-flex tw-items-center tw-pl-3 tw-pointer-events-none">
              <svg class="tw-w-4 tw-h-4 tw-text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"/>
              </svg>
            </div>
            <input
              type="search"
              class="tw-block tw-w-full tw-p-2 tw-pl-10 tw-text-sm tw-text-gray-900 tw-border tw-border-gray-300 tw-rounded-lg tw-bg-gray-50"
              placeholder="{{ browserLabel | translate }}"
              [(ngModel)]="searchTerm"
              [ngModelOptions]="{standalone: true}">
          </div>
        </div>
      </div>
    </div>
    
    <!-- Leyendas -->
    <div class="tw-flex-1">
      <div class="tw-grid tw-grid-cols-2 sm:tw-grid-cols-3 md:tw-grid-cols-4 tw-gap-x-4 tw-gap-y-2 tw-max-h-[110px] tw-overflow-y-auto tw-pr-2">
        <ng-container *ngFor="let data of filteredChartData; let i=index">
          <div
            class="tw-flex tw-items-center tw-space-x-2 tw-cursor-pointer tw-truncate"
            (click)="toggleLegend(data)"
            [class.tw-opacity-50]="data.hidden"
          >
            <i class="fas fa-circle tw-flex-shrink-0" [ngStyle]="{'color': getColorForItem(data, i) || '', 'font-size': '1.1rem'}"></i>
            <span class="tw-text-sm tw-text-gray-700 tw-truncate" [class.tw-line-through]="data.hidden">
              {{data.label}}
            </span>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>